<template>
  <el-checkbox-group :value="valueList" @input="change" :disabled="disabled">
    <el-checkbox v-for="item in checkList" :key="item.value" :label="item.value"
      >{{ item.label }}
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  props: {
    value: {},
    checkList: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    valueList() {
      if (!this.value) {
        return [];
      } else {
        return this.value.split(",");
      }
    },
  },
  methods: {
    change(v) {
      if (!v || v.length == 0) {
        this.$emit("input", "");
      } else {
        this.$emit("input", v.join(","));
      }
    },
  },
};
</script>


<style scoped>
</style>

